export default "__VITE_ASSET__CT_v3OtR__"